// extracted by mini-css-extract-plugin
module.exports = {"todo-item":"TodoItemCommon_todo-item__1k8Ni","todo-item--header":"TodoItemCommon_todo-item--header__1a3oi"};